'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fi_FI = require('../../date-picker/locale/fi_FI');

var _fi_FI2 = _interopRequireDefault(_fi_FI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _fi_FI2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/fi_FI.tsx
 ** module id = 763
 ** module chunks = 1
 **/